import { render } from "./QuestionnairesList.vue?vue&type=template&id=31152986"
import script from "./QuestionnairesList.vue?vue&type=script&lang=js"
export * from "./QuestionnairesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__